import { store, store$ } from '@redux/store';
import { getPaging, routingStateActions } from 'features/routing';
import ResultPresentationType from 'layout/constants/resultPresentationType';
import { selectResultsPresentationType } from 'layout/redux/selectors';
import { map, distinctUntilChanged, skip, filter } from 'rxjs';
import { selectPagingAndResultPresentationType } from '../redux/selectors';

const pagingBar = document.querySelector("[data-pagination]");
const pageNumberChange$ = store$.pipe(
  map(selectPagingAndResultPresentationType),
  filter((information) => information.resultsPresentationType !== ResultPresentationType.InfiniteScrolling.toString()),
  map((information) => information.page),
  map(Number),
  distinctUntilChanged(),
  skip(1),
);

/**
 * updateUrlPaging: Updates the page on the url.
 * @param {Number} pageNumber Number of the selected page.
 */
const updateUrlPaging = (pageNumber) => {
  const newPagingSegment = getPaging(pageNumber);
  
  store.dispatch(routingStateActions.updatePagination(newPagingSegment));
};

/**
 * togglePagingBarVisibility: shows or hides the paging bar in function of the current result type.
 * @param {ResultPresentationType} resultsPresentationType represents the current result presentation type.
 */
const togglePagingBarVisibility = (resultsPresentationType) => {
  if (resultsPresentationType === ResultPresentationType.InfiniteScrolling.toString()) {
    pagingBar.setAttribute("hidden", "");
  } else {
    pagingBar.removeAttribute("hidden");
  }
}

pageNumberChange$.subscribe(updateUrlPaging);

/**
 * Subscribing to the store and mapping changes on the ResultType of the search results page.
 */
store$.pipe(
  map(selectResultsPresentationType),
  distinctUntilChanged(),
).subscribe(togglePagingBarVisibility);